import { ElMessage } from "element-plus";
import Bus from "@/utils/bus";

export interface Data {
  type: "refreshList";
}
export type Func = (data: Data) => void;

class Broadcast {
  channel?: BroadcastChannel;
  queue: Set<Func> = new Set();

  constructor() {
    try {
      this.restore();
    } catch (error) {
      this.onMessageError();
    }
  }

  addListener(fn: Func) {
    this.queue.add(fn);
  }

  removeListener(fn: Func) {
    this.queue.delete(fn);
  }

  postMessage(data = { type: "refreshList" }) {
    this.channel && this.channel.postMessage(data);
  }

  onMessage(event: MessageEvent<Data>) {
    this.queue.forEach((fn) => {
      fn(event.data);
    });
  }

  onMessageError() {
    ElMessage.error("通信建立失败, 模板保存后请自行刷新列表页面");
  }

  close() {
    this.channel && this.channel.close();
  }

  restore() {
    this.queue = new Set();
    this.channel = new BroadcastChannel("print-template-design");
    this.channel.addEventListener("message", this.onMessage.bind(this));
    this.channel.addEventListener(
      "messageerror",
      this.onMessageError.bind(this)
    );
  }

  destroy() {
    if (this.channel) {
      this.channel.removeEventListener("message", this.onMessage);
      this.channel.removeEventListener("messageerror", this.onMessageError);
      this.close();
      this.channel = undefined;
    }
    this.queue.clear();
  }
}

const broadcast = new Broadcast();

// 添加刷新列表请求
broadcast.addListener((data: Data) => {
  console.log("####### broadcast", data);
  if (data.type === "refreshList") {
    Bus.emit("refresh-list");
  }
});

export default broadcast;
